<ng-container *ngIf="loadedTheme">
	<app-sidebar></app-sidebar>

	<app-header></app-header>

	<p-toast position="top-right"></p-toast>

	<main
		class="main"
		[class.margin__top__0]="!showMenu"
		[class.portal__manager]="!hasCategoryMenu"
	>
		<div class="main__wrapper" [@routeTransition]="prepareRoute(mainOutlet)">
			<router-outlet #mainOutlet="outlet"></router-outlet>
		</div>
	</main>

	<app-footer></app-footer>

	<p-scrollTop
		styleClass="scroll__top"
		behavior="smooth"
		[threshold]="200"
	></p-scrollTop>

	<app-whatsapp-button></app-whatsapp-button>
</ng-container>
